import React from 'react'
import { PureComponent } from 'react'
import GuchPendingTable from './GuchPendingTable'
import { listGuchPending, listDiagnoses } from '../rest/RESTUtils'
import { recordsToTree } from '../util/TreeDataUtils'
import WeeklyPlan from './WeeklyPlan'

class GuchPlanning extends PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      caseTypes: [],
      diagnoses: []
    }
  }
  
  init() {
    listDiagnoses(diagnoses => {
      listGuchPending((pending) => {
        this.setState({
          diagnoses: recordsToTree(diagnoses),
          pending: pending,
        })
      })
    })
  }

  onPendingChanged() {
    listGuchPending((pending) => {
      this.setState({
        pending: pending
      })
    })
  }

  componentDidMount() {
    this.init()
  }

  render () {
    return (
      <>
        { this.state.pending && (
          <>
            <GuchPendingTable caseTypes={this.state.caseTypes} diagnoses={this.state.diagnoses} pending={this.state.pending} 
              onChanged={() => this.onPendingChanged()}/>
            <WeeklyPlan caseTypes={this.state.caseTypes} diagnoses={this.state.diagnoses} pending={this.state.pending}/>
          </>
        )}
      </>
    )
  }
}

export default GuchPlanning
